import React from 'react';

interface ICustomBadgeProps {
  color?: string;
  children?: React.ReactNode;
  className?: string;
}

const CustomBadge = ({ color, children, className }: ICustomBadgeProps) => {
  return (
    <span className={`p-2 custom-badge ${color ? `bg-${color}` : ''} ${className}`}>
      {children}
    </span>
  );
};

export default CustomBadge;
